<template>
	<div class="container">
		<Navigation-bar title="裁判员详情"></Navigation-bar>
		<div class="container_content" v-if="pageShow">
			<div class="tabbar">
				<div class="tab_item" :class="{'active': tabActiveIndex == 0}" @click="switchTab(0)">证书</div>
				<div class="tab_item" :class="{'active': tabActiveIndex == 1}" @click="switchTab(1)">执裁经历</div>
			</div>
			<div class="tabbar_content">
			    <Scroll @scrollEnd="scrollEnd()">
                    <div class="item basic_info" :class="{'active': tabActiveIndex == 0}">
                        <div class="user_info">
                            <div class="portrait">
                                <img :src="detail.PortraitPhoto || portraitDefault"></img>
                            </div>
                            <div class="info-body">
                                <div class="name">
                                    <span>{{detail.Name}}</span>
                                    <img :src="sexSignUrl">
                                </div>
                                <div class="address" v-if="address">所属地: {{address}}</div>
                                <div class="age" v-if="detail.Age">年龄: {{detail.Age}}岁</div>
                                <div class="level">{{levelText}}</div>
                                <div class="authority" v-if="detail.RegisAssociation">注册协会: {{detail.RegisAssociation}}</div>
                            </div>
                        </div>
                        <div class="certificate_info">
                            <div class="date"><span>发证日期：{{date || '数据暂缺'}}</span></div>
                            <div class="certificate_no">{{detail.CurrentLevelCertNo || '数据暂缺'}}</div>
                        </div>
                    </div>
                    <div class="item" :class="{'active': tabActiveIndex == 1}">
                        <div class="experience_list" v-if="experienceList.length > 0">
                            <div class="experience_item" v-for="(item, index) in experienceList" :key="index" @click="go2ExperienceDetail(item.ExperienceId)">
                                <div class="item_header">
                                    <div class="match_name">{{item.JudgeLeague}}</div>
                                    <div class="button">详情</div>
                                </div>
                                <div class="item_content" v-if="item.WorkVouchers">
                                    <template v-for="(url, imageIndex) in [...item.WorkVouchers].splice(0, 6)">
                                        <div class="image_box more" :style="{'--num': getMoreNum(item.WorkVouchers.length)}" :key="imageIndex" v-if="item.WorkVouchers.length > 6 && imageIndex == 5">
                                            <img :src="ossThumb(url)" mode="aspectFill"></img>
                                        </div>
                                        <div class="image_box" :key="imageIndex" v-else>
                                            <img :src="ossThumb(url)" mode="aspectFill"></img>
                                        </div>
                                    </template>
                                </div>
                                <div class="item_footer">
                                    <div class="item_location">{{(item.HoldPlace || {}).RegionName || '未知'}}</div>
                                    <div class="item_date" v-if="item.HoldTime && item.HoldTime.BeginTime">{{formatDate(item.HoldTime.BeginTime)}}</div>
								    <div class="item_date" v-else></div>
                                </div>
                            </div>
                        </div>
				        <Text-prompt noDataImg="no_data/referee_experience@2x.png" :text="loadMore"></Text-prompt>
                    </div>
                </Scroll>
			</div>
		</div>
	</div>
</template>

<script>
	import utils from '@js/utils';
    import tools from '@/common/tools';
	export default{
		name: 'RefereeDetail',
		data(){
			return {
				pageShow: false,
                refereeId: 0,
				tabActiveIndex: 0,
				detail: {},
				experienceList: [],
				loadMore: ""
			}
		},
		created() {
			let refereeId = +this.$route.params.refereeId;
			if(refereeId){
                this.refereeId = refereeId;
				this.getOccupationDetail();
			}
		},
		computed: {
			portraitDefault(){
				if(this.detail.Gender == 2){
					return require("@/assets/occupation/images/detail_portrait_default_woman@2x.png");
				}else {
					return require("@/assets/occupation/images/detail_portrait_default_man@2x.png");
				}
			},
            sexSignUrl(){
				if(this.detail.Gender == 2){
					return require("@/assets/occupation/icon/sign_woman@2x.png");
				}else {
					return require("@/assets/occupation/icon/sign_man@2x.png");
				}
            },
			address(){
				let address,
					AddressInfo = this.detail.AddressInfo || {};
				if(AddressInfo.Country === "中国"){
					address = (AddressInfo.Region || {}).RegionName || "未知";
				}else{
					address = AddressInfo.Country || "未知";
				}
				return address;
			},
			levelText(){
				return `${this.detail.EventsName}${this.detail.CurrentLevelName || ''}裁判员`;
			},
			date(){
				return utils.getAbnormalDate(this.detail.CurrentLevelTime);
			},
			/// 获取赛事中最后一个Id
			lastId() {
				let length = this.experienceList.length;
				if (length > 0) {
					return this.experienceList[length - 1].ExperienceId;
				}
				return 0;
			}
		},
		methods: {
			formatDate(value){
				return tools.dateFormat(value, 'yyyy年MM月dd日');
			},
			getMoreNum(length){
				return `'+${length - 6}'`;
			},
			ossThumb(url){
				return url + '?x-oss-process=style/thumb_300';
			},
            scrollEnd(){
                this.GetUserRefereeExperienceList();
            },
			switchTab(index){
				this.tabActiveIndex = index;
				if(index == 1 && this.experienceList.length == 0){
					this.GetUserRefereeExperienceList(true);
				}
			},
			getOccupationDetail(){
				this.$api.GetRefereeDetail({
					RefereeId: this.refereeId
				}).then(data=>{
					this.pageShow = true;
					if(data.Code == 0){
						this.detail = data.RefereeDetail || {};
					}
				})
			},
            GetUserRefereeExperienceList(isReload){
				if(!isReload && ['到底了', '加载中'].includes(this.loadMore)) return;
				this.loadMore = "加载中";
				let lastId = isReload ? 0 : this.lastId;
				this.$api.GetUserRefereeExperienceList({
					"RefereeUserId": this.detail.UserId,
					"Continuation": {
						"LastId": lastId,
						"MaxCount": 20
					}
				}).then(data=>{
					this.loadMore = "加载更多";
					if (data.Code === 0) {
						let list = data.ContinueList || [];
						if(list.length == 0){
							if(isReload){
								this.experienceList = [];
								this.loadMore = "无数据";
							}else{
								this.loadMore = '到底了';
							}
						}else{
							if(isReload) {
								this.experienceList = list;
								if(list.length < 20){
									this.loadMore = '';
								}
							}else {
								this.experienceList.push(...list);
							}
						}
					}
				})
			},
			go2ExperienceDetail(id){
				this.$navigation.go(`/Occupation/RefereeExperienceDetail/${id}`);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container_content{
		.tabbar{
			width: 100%;
			height: 80px;
			background: #FFFFFF;
			border-bottom: 1px solid #E5E5E5;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			.tab_item{
				flex: 1;
				height: 100%;
				
				font-weight: 500;
				font-size: 32px;
				color: #1B1C1E;
				line-height: 80px;
				text-align: center;
				&.active{
					position: relative;
					color: #7AD21A;
					&::after{
						content: '';
						width: 100%;
						height: 2px;
						background-color: #7AD21A;
						position: absolute;
						bottom: -1px;
						left: 0;
					}
				}
			}
		}
		.tabbar_content{
			width: 100%;
			height: calc(100% - 80px);
            .scroll{
                width: 100%;
                height: 100%;
            }
			.item{
				display: none;
				&.active{
					display: block;
				}
			}
			.basic_info{
				.user_info{
					padding-top: 40px;
					position: relative;
					.portrait{
						width: 290px;
						height: 406px;
						border-radius: 20px;
						margin: 0 auto;
						margin-bottom: 32px;
						img{
							width: 100%;
							height: 100%;
							border-radius: 20px;
                            object-fit: cover;
						}
					}
					.info-body{
						padding: 0 40px;
						box-sizing: border-box;
						font-size: 28px;
						text-align: center;
						font-weight: 400;
						line-height: 40px;
						.name{
							display: flex;
							align-items: center;
							justify-content: center;
							span{
								font-size: 32px;
								color: #1B1C1E;
								font-weight: 500;
							}
							img{
								height: 36px;
								width: 36px;
								margin-left: 4px;
							}
						}
						.address{
							color: #1B1C1E;
							margin-top: 8px;
						}
						.age{
							color: #999999;
							margin-top: 16px;
						}
						.level{
							font-size: 36px;
							color: #CD860F;
							font-weight: 500;
							line-height: 50px;
							margin-top: 64px;
						}
						.authority{
							font-size: 24px;
							color: #D99015;
							line-height: 34px;
							margin-top: 8px;
						}
					}
				}
				.certificate_info{
					width: 540px;
					height: 186px;
					margin: 0 auto;
					margin-top: 32px;
					background: url("~@/assets/occupation/images/certificate_pattern@2x.png") no-repeat center / 100% 100%;
					padding-top: 14px;
					box-sizing: border-box;
					.date{
						width: 100%;
						height: 48px;
						display: flex;
						justify-content: center;
						span{
							height: 48px;
							border-bottom: 1px solid #E1E1E1;
								
							font-family: PingFangSC-Regular;
							font-size: 24px;
							color: #999999;
							font-weight: 400;
							line-height: 48px;
						}
					}
					.certificate_no{
						margin-top: 70px;
						
						font-family: PingFangSC-Regular;
						font-size: 28px;
						color: #CD860F;
						letter-spacing: 1px;
						text-align: center;
						font-weight: 400;
						line-height: 40px;
					}
				}
			}
			.experience_list{
				width: 100%;
				height: auto;
				padding: 40px;
				box-sizing: border-box;
				.experience_item{
					width: 100%;
					height: auto;
					padding-bottom: 32px;
					border-bottom: 2px solid #F0F0F0;
					margin-bottom: 32px;
					&:last-of-type{
						padding-bottom: 0;
						border-bottom: none;
						margin-bottom: 0;
					}
					.item_header{
						width: 100%;
						height: 40px;
						margin-bottom: 16px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						.match_name{
							width: calc(100% - 136px);
							height: 40px;
							
							font-weight: 400;
							font-size: 28px;
							color: #1B1C1E;
							line-height: 40px;
							@include ellipsis;
						}
						.button{
							width: 96px;
							height: 40px;
							border-radius: 20px;
							border: 1px solid #7AD21A;
							
							font-weight: 400;
							font-size: 24px;
							color: #7AD21A;
							line-height: 40px;
							text-align: center;
						}
					}
					.item_content{
						width: calc(100% + 8px);
						display: flex;
						flex-wrap: wrap;
						margin-bottom: 8px;
						.image_box{
							flex: none;
							width: 218px;
							height: 218px;
							margin-right: 8px;
							margin-bottom: 8px;
							&:nth-of-type(3n){
								margin-right: 0;
							}
							&.more{
								position: relative;
								&::after{
									content: var(--num);
									width: 100%;
									height: 100%;
									background: rgba(0,0,0,0.3);
									backdrop-filter: blur(0px);
									position: absolute;
									top: 0;
									left: 0;
									
									font-weight: 500;
									font-size: 40px;
									color: #FFFFFF;
									line-height: 218px;
									text-align: center;
								}
							}
							img{
								width: 100%;
								height: 100%;
								vertical-align: middle;
							}
						}
					}
					.item_footer{
						width: 100%;
						height: 34px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						flex-wrap: nowrap;
						.item_location{
							width: 100%;
							height: 34px;
							padding-left: 36px;
							box-sizing: border-box;
							background: url('~@/assets/occupation/icon/location-2@2x.png') no-repeat 0 center / 32px 32px;
							
							font-weight: 400;
							font-size: 24px;
							color: #999999;
							line-height: 34px;
							@include ellipsis;
						}
						.item_date{
							flex: none;
							font-weight: 400;
							font-size: 24px;
							color: #88919A;
							line-height: 34px;
						}
					}
				}
			}
		}
	}
</style>